import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconShoppingBag4"><Path fillRule="evenodd" clipRule="evenodd" d="M17 7H18.5C19.8807 7 21 8.11929 21 9.5V17.5C21 19.433 19.433 21 17.5 21H6.5C4.567 21 3 19.433 3 17.5V9.5C3 8.11929 4.11929 7 5.5 7H7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7ZM12 3C9.79086 3 8 4.79086 8 7H16C16 4.79086 14.2091 3 12 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag4;
